export const GET_TEST_RESULTS_OF_STUDENT_REQUEST =
  'GET_TEST_RESULTS_OF_STUDENT_REQUEST';
export const GET_TEST_RESULTS_OF_STUDENT_SUCCESS =
  'GET_TEST_RESULTS_OF_STUDENT_SUCCESS';
export const GET_TEST_RESULTS_OF_STUDENT_FAIL =
  'GET_TEST_RESULTS_OF_STUDENT_FAIL';
export const GET_TEST_RESULTS_OF_STUDENT_RESET =
  'GET_TEST_RESULTS_OF_STUDENT_RESET';

export const GET_TEST_RESULTS_OF_TEST_REQUEST =
  'GET_TEST_RESULTS_OF_TEST_REQUEST';
export const GET_TEST_RESULTS_OF_TEST_SUCCESS =
  'GET_TEST_RESULTS_OF_TEST_SUCCESS';
export const GET_TEST_RESULTS_OF_TEST_FAIL = 'GET_TEST_RESULTS_OF_TEST_FAIL';
export const GET_TEST_RESULTS_OF_TEST_RESET = 'GET_TEST_RESULTS_OF_TEST_RESET';

export const GET_TEST_RESULT_REQUEST = 'GET_TEST_RESULT_REQUEST';
export const GET_TEST_RESULT_SUCCESS = 'GET_TEST_RESULT_SUCCESS';
export const GET_TEST_RESULT_FAIL = 'GET_TEST_RESULT_FAIL';
export const GET_TEST_RESULT_RESET = 'GET_TEST_RESULT_RESET';
